import { render, staticRenderFns } from "./bar-pendidikan.vue?vue&type=template&id=5b80c068"
import script from "./bar-pendidikan.vue?vue&type=script&lang=js"
export * from "./bar-pendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports